export type ToggleDetail = {
  value: boolean;
};

export type ToggleActionOptions = {
  isDisabled?: boolean;
  onToggle?: (details: ToggleDetail) => void;
};

export type ToggleActionReturnType = {
  triggerProps: Record<string, any>;
};

/**
 * Use to provide support for toggles
 *
 * @returns
 */
export function useToggleAction({
  isDisabled,
  onToggle
}: ToggleActionOptions): ToggleActionReturnType {
  const triggerProps = isDisabled
    ? {}
    : {
        onAction: onToggle
      };

  return {
    triggerProps: triggerProps
  };
}
